import React from 'react';
import { motion } from 'framer-motion';

export default function DoctorNoteCard({ note }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="bg-desert-sand border-l-4 border-warm-brick p-8 rounded-r-lg"
      data-testid="doctor-note-card"
    >
      <div className="space-y-4">
        <h3 className="font-cormorant text-xl font-semibold text-dark-cedar">
          Dr. Soomin's Note
        </h3>
        <p className="font-cormorant italic text-lg text-dark-cedar/80 leading-relaxed">
          {note}
        </p>
      </div>
    </motion.div>
  );
}